import React, {useEffect, useState} from 'react';
import {
    setFilter,
    setForm,
    setItem,
    setLoading,
    setTableParams,
    setViewMode
} from "../../../redux/actions/generics/IndexedActions";
import {connect, useSelector} from "react-redux";
import {getStateByPath} from "../../../redux/selectors";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";
import {Card, CardBody, CardTitle, Col, Row} from "reactstrap";
import {GenericButton} from "../../../components/buttons/customButtons";
import UdnForm from "./_form";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {udnService} from "../../../jwt/_services";
import {showLoader} from "../../../components/loader/loader";

const UdnView = (props) => {
    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { path } = componentState;
    const { app, udn, loading } = componentState?.data;

    const [logoImage, setLogoImage] = useState( null);

    useEffect(() => {
        if( !app?.id || !udn.id )
            return

        const _filter = {
            fbDataBase : { id : app?.fbDataBase?.id },
            item : {
                code : udn.code
            }
        }
        setUdnHeader();
        genericIndexedActions.search(path, udnService, 0, 10, _filter)
    }, [ udn, app ]);

    useEffect(() => {
    }, [ udn ]);

    const editItem = () => {
        props.setForm(path, true, false, false);
        props.setItem(path, udn);

        ModalFormContainer(UdnForm, { path, udn, Form: UdnForm })
    };

    const setUdnHeader = () => {
        let img;

        try {
            img = require("../../../assets/images/logo/svg/" + udn?.code.toLowerCase() + ".svg");
        } catch (e) {
            img = require("../../../assets/images/icon/parks/svg/gpoxc-icon.svg");
        }

        setLogoImage(img);
    }

    const getFormulary = () => {
        switch (app?.code) {
            case "PARK" :
                return formPark()
            case "XKYNET" :
                return formPark()
            case "HCDP":
                return formHotel()
            case "HOTEL" :
                return formHotel()
            case "EVENTS" :
                return formEvents()
            case "FERRY" :
                return formFerry()
            default:
                return formPark()
        }
    }

    const formPark = () => {
        return <>
            <Row>
                <Col md={'6'}>
                    <img className={'home-udn-logo'} src={logoImage} alt={udn?.name}/>
                </Col>
                <Col md={'6'}>
                    <h2>{udn?.name || ''}</h2>
                    <h3>{udn?.langs?.find(l => l?.lang?.showOrder === 1)?.slogan || ''}</h3>
                    <br/>
                    <h3>{udn?.langs?.find(l => l?.lang?.showOrder === 1)?.address || ''}</h3>
                    <h3>{udn?.langs?.find(l => l?.lang?.showOrder === 1)?.schedule || ''}</h3>
                    <br/>
                </Col>
            </Row>
            <br/>
            <Row>
                <Col md={'12'}>
                    <h2><b>{'Descripción'}</b></h2>
                    <h3>{udn?.langs?.find(l => l?.lang?.showOrder === 1)?.description || ''}</h3>
                </Col>
            </Row>
            <br/>
            <Row>
                <Col md={'6'}>
                    <h2><b>{'Recomendaciones'}</b></h2>
                    <h3>{udn?.langs?.find(l => l?.lang?.showOrder === 1)?.recommendations || ''}</h3>
                </Col>
                <Col md={'6'}>
                    <h2><b>{'Incluido en tu compra:'}</b></h2>
                    <h3>{udn?.langs?.find(l => l?.lang?.showOrder === 1)?.included || ''}</h3>
                </Col>
            </Row>
        </>
    }

    const formHotel = () => {
        return <>
            <Row>
            <Col md={'6'}>
                    <img className={'home-udn-logo'} src={logoImage} alt={udn?.name}/>
                </Col>
                <Col md={'6'}>
                    <h2>{udn?.name || ''}</h2>
                    <h3>{udn?.langs?.find(l => l?.lang?.showOrder === 1)?.slogan || ''}</h3>
                    <h3>{udn?.langs?.find(l => l?.lang?.showOrder === 1)?.address || ''}</h3>
                </Col>
            </Row>
        </>
    }

    const formEvents = () => {
        return <>
            <Row>
                <Col md={'6'}>
                    <img className={'home-udn-logo'} src={logoImage} alt={udn?.name}/>
                </Col>
                <Col md={'6'}>
                    <h2>{udn?.name || ''}</h2>
                    <h3>{udn?.langs?.find(l => l?.lang?.showOrder === 1)?.slogan || ''}</h3>
                    <h3>{udn?.langs?.find(l => l?.lang?.showOrder === 1)?.address || ''}</h3>
                </Col>
            </Row>
        </>
    }

    const formFerry = () => {
        return <>
            <Row>
                <Col md={'6'}>
                    <img className={'home-udn-logo'} src={logoImage} alt={udn?.name}/>
                </Col>
                <Col md={'6'}>
                    <h2>{udn?.name || ''}</h2>
                    <h3>{udn?.langs?.find(l => l?.lang?.showOrder === 1)?.slogan || ''}</h3>
                    <h3>{udn?.langs?.find(l => l?.lang?.showOrder === 1)?.address || ''}</h3>

                </Col>
            </Row>
        </>
    }

    return <>
        { loading && showLoader() }
        <Card>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-list-alt mr-2"> </i>{'Unidad de negocio'}
                <br/>
                <h5 className={'card-modal-uid'}> {'     uid: ' + (udn?.uid || '')}</h5>
                <div className="top-right">
                    <GenericButton
                        style={'table'}
                        label={'Editar'}
                        toolTip={'Editar'}
                        icon={'fa-pen'}
                        permission={'edit'}
                        onClick={editItem}
                    />
                </div>
            </CardTitle>
            <CardBody className="">
                {getFormulary()}
            </CardBody>
        </Card>
    </>
}

const mapStateToProps = state => ({})

const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setViewMode,
    setForm,
    setItem,
    setLoading,
})
export default connect(mapStateToProps, mapActionsToProps)(UdnView)